<template>
    <div>
        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('line_message_count') }}
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="line_message_count"
                    @change="(val) => onchange('line_message_count',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                {{ $t('person_s') }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('user_count') }}
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="user_count"
                    @change="(val) => onchange('user_count',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                {{ $t('message_s') }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
  export default {
    props: ['line_message_count','user_count','onchange','disabled'],
    data () {
        return {

        }
    }
  }
</script>